export const MAPBOX_TOKEN = 'pk.eyJ1IjoiZXN0YXRlc2FuZHdpbmVzIiwiYSI6ImNsYndoMmdjMTA4dnMzb3J3enQ4cG03YjMifQ.emD4XgMdlt_2uqtHtMOI1g'
